import type { Color } from "@eu.mdotm.api/sphere";
import { getThemeCssVars, lazy } from "$root/utils";
import { themeCSSVars } from "@mdotm/shadcn/legacy/themes";
import { typedObjectValues } from "@mdotm/shadcn/legacy/utils";

export const tagColorMap: Record<
	Color,
	{ badgeColor: () => string; chartColor: () => string; label: string; key: Color }
> = {
	DEEP_RED: {
		badgeColor: lazy(() => getThemeCssVars(themeCSSVars.palette_R100)),
		chartColor: lazy(() => getThemeCssVars(themeCSSVars.palette_R300)),
		label: "Deep red",
		key: "DEEP_RED",
	},
	BRIGHT_RED: {
		badgeColor: lazy(() => getThemeCssVars(themeCSSVars.palette_D100)),
		chartColor: lazy(() => getThemeCssVars(themeCSSVars.palette_D300)),
		label: "Bright red",
		key: "BRIGHT_RED",
	},
	ORANGE: {
		badgeColor: lazy(() => getThemeCssVars(themeCSSVars.palette_W100)),
		chartColor: lazy(() => getThemeCssVars(themeCSSVars.palette_W300)),
		label: "Orange",
		key: "ORANGE",
	},
	YELLOW: {
		badgeColor: lazy(() => getThemeCssVars(themeCSSVars.palette_A100)),
		chartColor: lazy(() => getThemeCssVars(themeCSSVars.palette_A300)),
		label: "Yellow",
		key: "YELLOW",
	},
	LIGHT_BLUE: {
		badgeColor: lazy(() => getThemeCssVars(themeCSSVars.palette_S100)),
		chartColor: lazy(() => getThemeCssVars(themeCSSVars.palette_S300)),
		label: "Light blue",
		key: "LIGHT_BLUE",
	},
	BLUEBERRY: {
		badgeColor: lazy(() => getThemeCssVars(themeCSSVars.palette_B100)),
		chartColor: lazy(() => getThemeCssVars(themeCSSVars.palette_B300)),
		label: "Blueberry",
		key: "BLUEBERRY",
	},
	VIOLET: {
		badgeColor: lazy(() => getThemeCssVars(themeCSSVars.palette_V100)),
		chartColor: lazy(() => getThemeCssVars(themeCSSVars.palette_V300)),
		label: "Violet",
		key: "VIOLET",
	},
	GRAY: {
		badgeColor: lazy(() => getThemeCssVars(themeCSSVars.palette_N100)),
		chartColor: lazy(() => getThemeCssVars(themeCSSVars.palette_N300)),
		label: "Gray",
		key: "GRAY",
	},
	GREEN: {
		badgeColor: lazy(() => getThemeCssVars(themeCSSVars.palette_P100)),
		chartColor: lazy(() => getThemeCssVars(themeCSSVars.palette_P300)),
		label: "Green",
		key: "GREEN",
	},
};

export const tagColors = typedObjectValues(tagColorMap);
